/* ============================================
   JAMIE HALLER - KIWI SIZE CHART REPOSITIONING
   Moves Kiwi's .ks-chart-container to after 
   the unfolded product description
   ============================================ */

(function() {
  'use strict';

  function moveKiwiSizeChart() {
    // Find Kiwi's container - this is the exact class from their injection
    const kiwiElement = document.querySelector('.ks-chart-container, .sizing-chart-container');

    if (!kiwiElement) {
      console.log('Kiwi: .ks-chart-container not found yet');
      return false;
    }

    // Find the target: the unfolded description block
    const unfoldedDescription = document.querySelector('.product-accordion--unfolded');
    let targetBlock = null;
    
    if (unfoldedDescription) {
      // Get the parent product__block--accordion that contains the unfolded description
      targetBlock = unfoldedDescription.closest('.product__block--accordion');
    }
    
    // Fallback: find first accordion block if no unfolded description
    if (!targetBlock) {
      targetBlock = document.querySelector('.product__block--accordion');
    }
    
    // Fallback: find variant picker block
    if (!targetBlock) {
      targetBlock = document.querySelector('.product__block--lines');
    }

    if (!targetBlock) {
      console.log('Kiwi: Target block not found');
      return false;
    }

    // Check if already moved (avoid duplicate moves)
    if (kiwiElement.classList.contains('kiwi-repositioned')) {
      console.log('Kiwi: Already repositioned');
      return true;
    }

    // Create a wrapper div to match other block styling
    const wrapper = document.createElement('div');
    wrapper.className = 'product__block product__block--kiwi kiwi-repositioned';
    wrapper.style.cssText = 'padding: 8px 0; margin-bottom: 0;';
    
    // Move Kiwi into the wrapper
    kiwiElement.parentNode.insertBefore(wrapper, kiwiElement);
    wrapper.appendChild(kiwiElement);
    
    // Insert the wrapper after the target block
    targetBlock.parentNode.insertBefore(wrapper, targetBlock.nextSibling);
    
    console.log('Kiwi: Size Chart moved to after description');
    return true;
  }

  // Wait for DOM and Kiwi to load
  function init() {
    // Try immediately
    if (moveKiwiSizeChart()) return;

    // Poll for Kiwi to inject (it loads async via their script)
    let attempts = 0;
    const maxAttempts = 40; // 10 seconds max

    const interval = setInterval(() => {
      attempts++;
      if (moveKiwiSizeChart() || attempts >= maxAttempts) {
        clearInterval(interval);
        if (attempts >= maxAttempts) {
          console.log('Kiwi: Timeout - Size Chart may not exist on this product');
        }
      }
    }, 250);
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    // Small delay to let Kiwi inject first
    setTimeout(init, 100);
  }

  // Also run when variant changes (Kiwi might re-inject)
  document.addEventListener('variant:change', function() {
    setTimeout(function() {
      // Remove repositioned class to allow re-check
      const existing = document.querySelector('.kiwi-repositioned');
      if (existing) {
        existing.classList.remove('kiwi-repositioned');
      }
      moveKiwiSizeChart();
    }, 500);
  });

})();